
<style scoped>
.accent {
  background-color: white !important;
  border-color: white !important;
}
.lDiv {
  float: left;
}
.lPoints {

}

</style>

<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div :key="keyIndex" :class="myClassName">
    <v-layout v-if="showPoints" row wrap class="pb-1">
      (
      <span v-if="showPoints">Obergrenze: {{previewData.punkte_Obergrenze}}, </span>
      <span v-if="showPoints">Untergrenze: {{previewData.punkte_Untergrenze}}</span>
      <span v-if="showPoints && previewData.gesamtrichtigkeit_relevant">,&nbsp;Gesamtrichtigkeit: Frage ist komplett richtig zu lösen</span>
      <span v-if="showPoints && !previewData.gesamtrichtigkeit_relevant && isFreeAnswer(previewData)">,&nbsp;Gesamtrichtigkeit: Falsche Antworten sind erlaubt</span>
      )
    </v-layout>
    <table width="100%">
      <tr v-for="(row, i) in rows" v-bind:key="i">
        <td v-for="(item, ii) in getccc(previewData.contents, row)" :width="getCellWidth(item)"
            v-bind:key="ii" :rowspan="getRowSpan(item)" :colspan="getColSpan(item)"
            :align="getTDAlign(item)"
            :valign="getTDVAlign(item)"
            :style="getStyle(item)">

          <v-layout v-if="item.Format === 'TXT' && getInhalt(item) && getInhalt(item).length > 0">
            <v-flex class="text-xs-left font-weight-bold mb-5 subheading" v-if="!hasLatex(item)">
              <div :class="'cell' + item.Format">
                <span class="subMarker" v-if="item.Zeile === indexOfFirstText && ('' + nodeId).length > 0">{{qIndex}}.{{ (nodeId + 1)}}.</span>
                <span v-if="!isLatex(item)" v-html="getInhalt(item)" class="cell cellTXT"></span>
                <katex-element :displayMode="true" v-if="isLatex(item)" :expression="getLatex(item)"/>
              </div>
            </v-flex>

            <v-flex class="text-xs-left font-weight-bold mb-5 subheading" v-if="hasLatex(item)">
              <div :class="'cell' + item.Format">
                <span class="subMarker" v-if="item.Zeile === indexOfFirstText && ('' + nodeId).length > 0">{{qIndex}}.{{ (nodeId + 1)}}.</span>
                <div v-for="entry in getInhaltAsList(item)">
                  <span v-if="!isLatexTag(entry)" v-html="getInhaltFromHTML(entry)" class="cell cellTXT"></span>
                  <katex-element :displayMode="true" v-if="isLatexTag(entry)" :expression="getLatexFromHTML(entry)"/>
                </div>
              </div>
            </v-flex>
          </v-layout>
          <!--
          <v-layout v-if="item.Format === 'TXT' && getInhalt(item) && getInhalt(item).length > 0">
            <v-flex class="text-xs-left font-weight-bold mb-5 subheading">

              <span class="subMarker" v-if="item.Zeile === indexOfFirstText && ('' + nodeId).length > 0">{{qIndex}}.{{ (nodeId + 1)}}.</span>
              <span v-if="!isLatex(item)" v-html="getInhalt(item)" class="cell cellTXT"></span>
              <katex-element :displayMode="true" v-if="isLatex(item)" :expression="getLatex(item)"/>
            </v-flex>
          </v-layout>
          -->
          <v-layout v-if="item.Format === 'ANX'" class="pa-0 my-1 text-xs-left align-start " row wrap>
            <v-flex xs12 :color="getColor(item)" :style="'border: 1px solid ' + getBorderColor(item) + ';' + getCheckboxStyle(item)">
              <div class="lettercheckbox handpointer" @click="checkboxQuestion(item)">
                <v-icon style="float:left; padding-right: 4px;" large color="examenis" v-if="isMarker(item)">check_box</v-icon>
                <v-icon style="float:left; padding-right: 4px;" large color="examenis" v-if="!isMarker(item)">check_box_outline_blank</v-icon>
                <span style="position: inherit;margin-left: -27px;margin-top:7px;font-size: 16px;float:left;" v-if="!isMarker(item)">{{ getCBMarkerText(item) }} </span>
                <span style="position: inherit;margin-left: -27px;margin-top:7px;font-size: 16px;float:left;" v-if="isMarker(item)"> </span>
              </div>

              <div v-if="!hasLatex(item)" class="lDiv">
                <div v-if="!isLatex(item)" style="'vertical-align: middle;display:table;" :class="'cell cell' + item.Format" v-html="getInhalt(item)">
                  <span class="black--text" style="display:table-cell;vertical-align:middle;"></span>
                </div>
                <katex-element :displayMode="true" v-if="isLatex(item)" :expression="getLatex(item)"/>
              </div>

              <div v-if="hasLatex(item)" class="lDiv">
                <div v-for="entry in getInhaltAsList(item)">
                  <div v-if="!isLatexTag(entry)" style="'vertical-align: middle;display:table;" :class="'cell cell' + item.Format" v-html="getInhaltFromHTML(entry)">
                    <span class="black--text" style="display:table-cell;vertical-align:middle;"></span>
                  </div>
                  <katex-element :displayMode="true" v-if="isLatexTag(entry)" :expression="getLatexFromHTML(entry)"/>
                </div>
              </div>
              <!--

              <div v-if="!isLatex(item)" style="vertical-align: middle;display:table;" :class="'cell cell' + item.Format" v-html="getInhalt(item)">
                <span class="black--text" style="display:table-cell;vertical-align:middle;"></span>
              </div>
              <katex-element style="float:left;" :displayMode="true" v-if="isLatex(item)" :expression="getLatex(item)"/>
              -->
              <!--
              <v-checkbox :color="getColor(item)" v-model="item.Marker" @change="updateValue(item)" true-value="True"
                          :style="'border: 1px solid ' + getBorderColor(item) + ';' + getCheckboxStyle(item)">
                <template v-slot:label>
                  <span v-if="!isLatex(item)" v-html="getInhalt(item)" class="black--text"></span>
                  <katex-element v-if="isLatex(item)" :expression="getLatex(item)"/>
                </template>
              </v-checkbox>
              -->
            </v-flex>
            <v-flex xs12 v-if="showPoints">
              <span class="lPoints">(Punkte: {{item.Punkte}})</span>
            </v-flex>
          </v-layout>
          <v-layout v-if="item.Format === 'HEX'" class="pa-0 my-2">
            <v-flex>
              <v-img
                :src="getHexUrl(item)"
                :aspect-ratio="getRatio(item)"
                v-if="item.Format === 'HEX'"
                :ref="'img' + item.ID"
                :maxWidth="item.width"
                :maxHeight="item.height"
                contain
              >
                <!--
                :maxWidth="item.width"
                :maxHeight="item.height"

                -->
              </v-img>
            </v-flex>
          </v-layout>
          <div v-if="item.Format === 'JPG'" class="previewImage" name="imageHolder" :style="item.imageHolderStyle">
            <div :style="item.myJPGStyle">

            </div>
          </div>
          <!--
          <div v-if="item.Format === 'JPG'" class="previewImage" :style="item.jpgStyle"></div>
          -->
          <v-layout v-if="false && item.Format === 'JPG'" class="pa-0 my-2">
            <v-flex class="fluid">
              <v-flex class="" :style="getJPGStyle(item)"></v-flex>
              <!--
              <v-img
                :src="getJPGUrl(item)"
                :lazy-src="getJPGUrl(item)"
                :ref="'img' + item.ID"
                contain
              >
              -->
                <!--
                :aspect-ratio="getRatio(item)"
                :maxWidth="item.width"
                :maxHeight="item.height"



                :key="Math.random()"
                :maxWidth="item.width"
                :maxHeight="item.height"

              </v-img>
                -->
            </v-flex>
          </v-layout>
          <v-layout v-if="previewData.Typ === '20' && item.Format === 'ANT'" class="pa-0 my-2">
            <v-flex>
              <v-textarea
                v-model="item.Marker"
                label="Antwortfeld"
                box
                @change="updateValue(item)"
                color="examenis"
                class="inputANT20"
                background-color="examenishell"></v-textarea>
            </v-flex>
          </v-layout>
          <v-layout v-if="previewData.Typ === '2' && item.Format === 'ANT'" class="pa-0 my-2">
            <v-flex>
              <v-text-field
                v-model="item.Marker"
                label="Antwortfeld"
                box
                @change="updateValue(item)"
                color="examenis"
                class="inputANT2"
                background-color="examenishell"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout v-if="!(previewData.Typ === '2' || previewData.Typ === '20') && item.Format === 'ANT'" class="pa-0 my-2">
            <v-flex>
              <v-text-field
                v-model="item.Marker"
                label="Antwortfeld"
                box
                @change="updateValue(item)"
                color="examenis"
                class="inputANT"
                background-color="examenishell"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout
            v-if="(item.Format !== 'ANT') && (item.Format !== 'ANX') && item.Format !== 'TXT' && item.Format !== 'JPG' && item.Format !== 'HEX'"
            justify-start
            class="pa-0 red">
            <span v-if="showPoints">{{item.Punkte}}</span>
            {{item.Format}}
            {{item.Typ}}
          </v-layout>
        </td>
      </tr>
    </table>
    <!--
    <v-layout v-for="(row) in rows" :key="row" row wrap class="pa-0">
      <v-flex v-for="(item) in previewData.contents" :class="getCellClass(item)" :key="item.Zeile + '' + item.Spalte"
              v-if="item.Zeile === row">
        <v-layout v-if="item.Format === 'TXT'">
          <v-flex class="text-xs-left font-weight-bold mb-5 subheading">
            <span v-if="!isLatex(item)" v-html="getInhalt(item)"></span>
            <katex-element v-if="isLatex(item)" :expression="getLatex(item)"/>
          </v-flex>
        </v-layout>
        <v-layout v-if="item.Format === 'ANX'" class="pa-0 my-1 text-xs-left" row>
          <v-flex>
            <v-checkbox :color="getColor(item)" v-model="item.Marker" @change="updateValue(item)" true-value="True" :style="'border: 1px solid ' + getBorderColor(item) + ';'">
              <template v-slot:label>
                <span v-if="!isLatex(item)" v-html="getInhalt(item)" class="black--text"></span>
                <katex-element v-if="isLatex(item)" :expression="getLatex(item)"/>
              </template>
            </v-checkbox>
            <span v-if="showPoints">(Punkte: {{item.Punkte}})</span>
          </v-flex>
        </v-layout>
        <v-layout v-if="item.Format === 'HEX'" class="pa-0 my-2">
          <v-flex class="text-xs-left">
            <v-img
              :src="getHexUrl(item)"
              :lazy-src="getHexUrl(item)"
              :aspect-ratio="getRatio(item)"
              contain
            >
            </v-img>
          </v-flex>
        </v-layout>
        <v-layout v-if="item.Format === 'JPG'" class="pa-0 my-2">
          <v-flex class="text-xs-left">
            <v-img
              :src="getJPGUrl(item)"
              :lazy-src="getJPGUrl(item)"
              :aspect-ratio="getRatio(item)"
              contain
            >
            </v-img>
          </v-flex>
        </v-layout>
        <v-layout
          v-if="(item.Format !== 'ANX') && item.Format !== 'TXT' && item.Format !== 'JPG' && item.Format !== 'HEX'"
          justify-start
          class="pa-0 red">
          <span v-if="showPoints">{{item.Punkte}}</span>
          {{item.Format}}
          {{item.Typ}}
        </v-layout>
      </v-flex>
    </v-layout>
    -->
  </div>
</template>

<script>
  import Vue from 'vue'
  var _ = require('lodash')

  export default {
    name: 'PreviewItem',
    components: {},
    props: ['itemId', 'previewData', 'showPoints', 'isOnline', 'nodeId', 'indexOfFirstText', 'qIndex'],
    methods: {
      checkboxQuestion: function (item) {
        if (item.Marker) {
          item.Marker = false
        } else {
          item.Marker = true
        }
        this.updateValue(item)
        if (this.singleSelection) {
          if (('' + item.Marker).toLowerCase() === 'true') {
            for (let index in this.previewData.contents) {
              let oItem = this.previewData.contents[index]
              if (oItem && oItem.Format === 'ANX') {
                if (item !== oItem) {
                  if (('' + oItem.Marker).toLowerCase() === 'true') {
                    oItem.Marker = false
                    this.updateValue(oItem)
                  }
                }
              }
            }
          }
        }
      },
      isMarker: function (item) {
        if (!item) return false
        let result = item.Marker === true || item.Marker === 'true' || ('' + item.Marker).toLowerCase() === 'true'
        return result
      },
      open: function () {
        this.keyIndex = this.keyIndex++
        this.getItemValues()
      },
      isFreeAnswer: function (item) {
        return item.type === '20' || item.type === '2'
      },
      getccc: function (d, row) {
        var arr = []
        for (var index in d) {
          var item = d[index]
          if (item.Zeile === row) {
            arr.push(item)
          }
        }
        var sorted = _.sortBy(arr, ['Spalte'])
        return sorted
      },
      getColor: function (item) {
        var res = 'examenis'
        if (item.compareData) {
          if (item.Format === 'ANX') {
            if (item.Marker.toLowerCase() === 'true') {
              if (item.compareData.Marker.toLowerCase() === 'true') {
                res = 'green'
              } else if (item.compareData.Marker.toLowerCase() !== 'true') {
                res = 'red'
              }
            } else {
              if (item.compareData.Marker.toLowerCase() === 'true') {
                res = 'yellow'
              }
            }
          }
        }
        return res
      },
      getRowSpan: function (item) {
        let rowSpan = 1
        if (item.config) {
          rowSpan = ('0' + item.config.rowSpan) * 1
        }
        if (rowSpan <= 0) {
          rowSpan = 1
        }
        return rowSpan
      },
      hexEncode (str) {
        var hex, i
        var result = ''
        for (i = 0; i < str.length; i++) {
          hex = str.charCodeAt(i).toString(16)
          result += ('000' + hex).slice(-4)
        }
        return result
      },
      hexDecode (str) {
        var j
        var hexes = str.match(/.{1,4}/g) || []
        var back = ''
        for (j = 0; j < hexes.length; j++) {
          back += String.fromCharCode(parseInt(hexes[j], 16))
        }
        return back
      },
      getColSpan: function (item) {
        let colSpan = 1
        if (item.config) {
          colSpan = ('0' + item.config.colSpan) * 1
        }
        if (colSpan <= 0) {
          colSpan = 1
        }
        return colSpan
      },
      getStyle: function (item) {
        var style = ''
        if (item.config) {
          style += 'vertical-align:'
          if (item.config.verticalAlign === '0') {
            style += 'top'
          } else if (item.config.verticalAlign === '1') {
            style += 'middle'
          } else if (item.config.verticalAlign === '2') {
            style += 'bottom'
          }
          style += ';'
        }
        style += ';height: 1px;'
        return style
      },
      getCBMarkerText: function (item) {
        let ch = String.fromCharCode(65 + item.index)
        return '' + ch
      },
      getCheckboxStyle: function (item) {
        var style = ''
        if (item.config) {
          style += 'vertical-align:'
          if (item.config.verticalAlign === '0') {
            style += 'top; margin-top:0px; padding-top:0px;'
          } else if (item.config.verticalAlign === '1') {
            style += 'middle'
          } else if (item.config.verticalAlign === '2') {
            style += 'bottom; margin-bottom:0px; padding-bottom:0px;'
          }
          style += ';'
        }
        return style
      },
      getBorderColor: function (item) {
        var res = 'hidden'
        if (item.compareData) {
          if (item.Format === 'ANX') {
            if (item.Marker.toLowerCase() === 'true') {
              if (item.compareData.Marker.toLowerCase() === 'true') {
//                res = 'green'
              } else if (item.compareData.Marker.toLowerCase() !== 'true') {
//                res = 'red'
              }
            } else {
              if (item.compareData.Marker.toLowerCase() === 'true') {
                res = 'red'
              }
            }
          }
        }
        return res
      },
      getRatio: function (item) {
        if (item.width) {
          return item.width / item.height
        }
        return 1.5
      },
      getCountOfColumnsIn: function (zeile) {
        var cnt = 0
        for (var index in this.previewData.contents) {
          var content = this.previewData.contents[index]
          if (content.Zeile === zeile) {
            cnt++
          }
        }
        return cnt
      },
      getCountOfMaxColumns: function () {
        var cnt = 0
        var cntProZeile = []
        for (var index in this.previewData.contents) {
          var content = this.previewData.contents[index]
          if (!cntProZeile[content.Zeile]) {
            cntProZeile[content.Zeile] = {}
          }
          cntProZeile[content.Zeile][content.Spalte] = content.Spalte
          cnt = Math.max(cnt, Object.keys(cntProZeile[content.Zeile]).length)
        }
        return cnt
      },
      getCellWidth: function (item) {
        var cnt = this.getCountOfMaxColumns()
        // var cnt = this.getCountOfColumnsIn(item.Zeile)
        var width = (100 / cnt)
        if (item.config && item.config.colSpan !== -1) {
          width = width * item.config.colSpan
        }
        width = width + '%'
        if (width === '100%') return ''
        return width
      },
      getCellClass: function (item) {
        /*
        var cnt = 0
        for (var index in this.previewData.contents) {
          var content = this.previewData.contents[index]
          if (content.Zeile === item.Zeile) {
            cnt++
          }
        }
         */
        // md' + Math.round(12 / cnt)
        return ''
      },
      getImageHolderStyle: function (item) {
        let height = item.height
        let maxHeight = item.height
        if (item.config) {
          if (!this.isPrint) {
            if (item.config.imageMaxHeightO * 1 !== -1) {
              maxHeight = item.config.imageMaxHeightO * 1
            }
          } else {
            if (item.config.imageMaxHeight * 1 !== -1) {
              maxHeight = item.config.imageMaxHeight * 1
            }
          }
        }
        if (height > maxHeight) {
          height = maxHeight
        }
        let css = 'width: 100%; height: ' + height + 'px;'
        return css
      },
      getJPGStyle: function (item) {
        item.jpgStyle = ''
        // <div class="v-image__image v-image__image--contain" style=""></div>
        // let url = this.getJPGUrl(item)
        var url = Vue.prototype.$api.getJPGURL(item, this.previewData.ID)
        // + '?time' + new Date().getTime()
        // let w = this.getCellWidth(item)
        let ho = 'center'
        let ve = 'center'
        let css = 'background-size:contain;background-image: url("' + url + '")'
        let maxWidth = -1
        let maxHeight = -1
        let width = item.width
        let height = item.height
        if (item.config) {
          if (item.config.hAlign === '0') {
            ho = 'left'
          }
          if (item.config.hAlign === '1') {
            ho = 'center'
          }
          if (item.config.hAlign === '2') {
            ho = 'right'
          }
          if (this.isPrint) {
            if (item.config.imageMaxWidth * 1 !== -1) {
              maxWidth = item.config.imageMaxWidth * 1
            }
            if (item.config.imageMaxHeight * 1 !== -1) {
              maxHeight = item.config.imageMaxHeight * 1
            }
          } else {
            if (item.config.imageMaxWidthO * 1 !== -1) {
              maxWidth = item.config.imageMaxWidthO * 1
            }
            if (item.config.imageMaxHeightO * 1 !== -1) {
              maxHeight = item.config.imageMaxHeightO * 1
            }
          }
        }
        if (maxWidth !== -1) {
          // css += ';max-width: ' + maxWidth + 'px'
        }
        if (maxHeight !== -1) {
          if (height > maxHeight) {
            height = maxHeight
          }
        }
        if (width > maxWidth) {
          width = maxWidth
        }
        css += ';height:' + height + 'px'
        // css += ';width:' + width + 'px'
        css += ';background-position: ' + ho + ' ' + ve + ';'
        item.jpgStyle = css
        return css
      },
      getJPGUrl: function (item, callback) {
        // var cmp = this
        // var idItem = item.ID
        var url = Vue.prototype.$api.getJPGURL(item, this.previewData.ID)
        // + '?time' + new Date().getTime()
        var i = new Image()
        i.onload = function () {
          item.width = i.width
          item.height = i.height
          // cmp.$refs['img' + idItem][0].maxHeight = item.height
          // cmp.$refs['img' + idItem][0].maxWidth = item.width
        }
        i.src = url
        return url
      },
      getTDAlign: function (item) {
        var align = 'left'
        if (item.config) {
          if (item.config.align === '0') {
            align = 'left'
          } else if (item.config.verticalAlign === '1') {
            align = 'center'
          } else if (item.config.verticalAlign === '2') {
            align = 'right'
          }
        }
        return align
      },
      getTDVAlign: function (item) {
        var align = 'top'
        if (item.config) {
          if (item.config.align === '0') {
            align = 'top'
          } else if (item.config.verticalAlign === '1') {
            align = 'middle'
          } else if (item.config.verticalAlign === '2') {
            align = 'bottom'
          }
        }
        return align
      },
      getHexUrl: function (item) {
        var cmp = this
        var idItem = item.ID
        var url = Vue.prototype.$api.getHexURL(item, this.previewData.ID)
        // + '?time' + new Date().getTime()
        var i = new Image()
        i.onload = function () {
          item.width = i.width
          item.height = i.height
          cmp.$refs['img' + idItem][0].maxHeight = item.height
          cmp.$refs['img' + idItem][0].maxWidth = item.width
        }
        i.src = url
        return url
      },
      isLatex: function (item) {
        var latex = this.getInhalt(item)
        var idx2 = latex.indexOf('LATEX=')
        return (idx2 > -1)
      },
      isLatexTag: function (latex) {
        latex = '' + latex
        var idx = latex.indexOf('<span class="latexCode">')
        var idx2 = latex.indexOf('LATEX=')
        return (idx2 > -1) || (idx > -1)
      },
      hasLatex: function (item) {
        var latex = this.getInhalt(item)
        var idx = latex.indexOf('<span class="latexCode">')
        return (idx > -1)
      },
      getLatexFromHTML: function (latex) {
        latex = '' + latex
        var bodyFound = false
        var idx = latex.indexOf('$')
        if (idx > -1) {
          latex = latex.substr(idx + 1)
        }
        idx = latex.indexOf('$')

        if (!bodyFound) {
          // latex = this.getInhalt(item)
          latex = window.jQuery('<textarea />').html(latex).text()
          latex = Vue.prototype.$api.replaceAll(latex, '\\$', '')
          latex = Vue.prototype.$api.replaceAll(latex, '<latex>', '')
          latex = Vue.prototype.$api.replaceAll(latex, '</latex>', '')
          latex = Vue.prototype.$api.replaceAll(latex, '<span class="latexCode">', '')
          latex = Vue.prototype.$api.replaceAll(latex, '</span>', '')
          latex = Vue.prototype.$api.replaceAll(latex, 'LATEX=', '')
          var key = '\\begin{document}'
          idx = latex.indexOf(key)
          if (idx > -1) {
            latex = latex.substr(idx + key.length)
          }
          latex = Vue.prototype.$api.replaceAll(latex, '\\\\thispagestyle{empty}', '')
          latex = Vue.prototype.$api.replaceAll(latex, '\\\\end{document}', '')
          latex = Vue.prototype.$api.replaceAll(latex, '<br>', '')
        }
        return latex
      },
      getLatex: function (item) {
        var latex = this.getInhalt(item)
        return this.getLatexFromHTML(latex)
      },
      updateValue: function (item) {
        var items = this.getItemValues()
        this.$emit('updateValue', items, item)
      },
      refreshLayout: function () {
        this.keyIndex = this.keyIndex + 1
      },
      getItemValues: function () {
        var items = []
        this.singleSelection = false
        if (this.previewData.Antwortfolge === 'Single') {
          this.singleSelection = true
        }
        let anxIndex = 0
        for (var index in this.previewData.contents) {
          var content = this.previewData.contents[index]
          content.ci = index
          if (content.config) {
            try {
              content.config = JSON.parse(content.config)
            } catch (err) {
            }
          }
          if (content.Format === 'JPG') {
            content.myJPGStyle = this.getJPGStyle(content)
            content.imageHolderStyle = this.getImageHolderStyle(content)
          }
          if (content.Format === 'ANX') {
            content.index = anxIndex++
          }
          items.push(content)
        }
        return items
      },
      getInhaltAsList: function (item) {
        if (!item) return ''
        var content = this.getInhaltFromHTML(item.Inhalt)
        this.getItemValues()
        let list = []
        let s = 0
        let p = content.indexOf('<span class="latexCode">')
        while (p > -1) {
          let sub = content.substr(s, p)
          list.push(sub)
          let res = content.substr(p)
          let e = res.indexOf('</span>')
          let latexCode = res.substr(0, e + '</span>'.length)
          list.push(latexCode)
          content = content.substr(p + latexCode.length)
          p = content.indexOf('<span class="latexCode">')
          if (p === -1) {
            list.push(content)
          }
        }
        return list
      },
      replaceSpanInnerText: function (htmlString, replacements, classReplacements = {}) {
        return htmlString.replace(
          /<span class="[^"]*\bgap-placeholder\b[^"]*" data-id="(gap-\d+)">(.*?)<\/span>/g,
          (match, dataId, innerContent) => {
            // Bestimme den neuen Textinhalt (falls vorhanden)
            const newContent = replacements[dataId] !== undefined ? replacements[dataId] : innerContent

            // Bestimme die neue Klasse (falls vorhanden)
            const newClass = classReplacements[dataId] || 'gap-placeholder'

            // Erzeuge das neue <span>-Element
            const rep = `<span class="${newClass}" data-id="${dataId}">${newContent}</span>`
            console.log('match', match, dataId, rep, newContent)
            return rep
          }
        )
      },
      doReplacements: function (content, config) {
        console.log('doReplacements', content, config)
        if (config) {
          let replacements = {}
          let classReplacements = {}
          for (const index in config.gapConfigs) {
            const cfg = config.gapConfigs[index]
            replacements[cfg.uid] = cfg.type
            if (cfg.type === 'text') {
              replacements[cfg.uid] = '<input type="text" name="gap-value-' + cfg.uid + '">'
            }
            if (cfg.type === 'check') {
              replacements[cfg.uid] = '<label class="custom-checkbox">\n' +
                '  <input name="gap-value-' + cfg.uid + '" type="checkbox" />\n' +
                '  <div class="checkbox"></div>\n' +
                '' +
                '</label>'
            }
            classReplacements[cfg.uid] = 'gap-placeholder gap-' + cfg.type
          }
          content = this.replaceSpanInnerText(content, replacements, classReplacements)
        }
        console.log('doReplacements', content)
        return content
      },
      getInhaltFromHTML: function (content, config) {
        if (!content) return ''
        if (content.startsWith('BASE64')) {
          content = content.substr('BASE64'.length)
          content = this.hexDecode(content)
          content = this.doReplacements(content, config)
          return content
        }
        content = Vue.prototype.$api.replaceAll(content, 'ë', '"')
        content = Vue.prototype.$api.replaceAll(content, 'ï', '\n')
        content = Vue.prototype.$api.replaceAll(content, 'ú', '\\')
        content = Vue.prototype.$api.replaceAll(content, 'ÿ', '\'')
        content = Vue.prototype.$api.replaceAll(content, 'ù', '')
        content = this.doReplacements(content, config)
        return content
      },
      getInhalt: function (item) {
        if (!item) return ''
        var content = this.getInhaltFromHTML(item.Inhalt, item.config)
        this.getItemValues()
        return content
      }
    },
    data () {
      return {
        isPrint: false,
        myClassName: 'online',
        singleSelection: false,
        dummyAnswer: '',
        on: false,
        compareItems: null,
        keyIndex: 0,
        rows: [1, 2, 3, 4, 5, 6, 7]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/widgets/PreviewItem.vue